<template>
	<div class="p-0 h-100 d-flex flex-column" style="overflow: hidden;">
		<div class="bg-light-noise result-topbar" v-if="displayHeader">
			<nav class="navbar navbar-expand-lg navbar-light w-100 py-1 d-flex flex-row">
			  <div class="navbar-brand mr-3" v-if="pages.total > 0">{{pages.data[0].document.document_name}}</div>
			  <div class="navbar-brand mr-3" v-else>{{ __('translations.notebooks') }}</div>
			  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			    <span class="navbar-toggler-icon"></span>
			  </button>
			  <div v-if="pages.total > 0" class="collapse navbar-collapse" id="navbarSupportedContent">
			    <div class="flex-grow-1">
			    	<searchbar :max-tags="5" :focus-on-render="false" :display-search-options="false"></searchbar>
			    </div>
			  </div>
			</nav>
		</div>
        <div class="result-content p-3" style="flex: 1; overflow-y: auto;">
        	<div class="row">
	        	<section id="image-results" class="image-grid--compact cf">
					<page-result v-for="page in pages.data" :key="page.id" class="animated fadeIn" :page="page"></page-result>
				</section>
			</div>
			<div v-if="pages.total == 0">
		   		<div class="text-muted">{{ __('translations.message.no_documents_found') }}</div>
		    </div>
		</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import PageResult from '../components/PageResult'

export default {
	name: "Pages",
	props: ['displayHeader'],
	components: {
		PageResult
	},
	computed: {
		...mapGetters([
			'pages'
		])
	},
	created() {
		this.fetchPages();
	},
	watch: {
	    $route(to, from) {
	    	this.fetchPages();
	    }
	},
	methods: {
		fetchPages() {
			if(this.$route.name === 'document') {
				this.$store.dispatch('SELECT_DOC', {'id': this.$route.params.id});
			}
		},
	}
}
</script>
